import { render, staticRenderFns } from "./formMCQResponses.vue?vue&type=template&id=655809d0&scoped=true&"
import script from "./formMCQResponses.vue?vue&type=script&lang=js&"
export * from "./formMCQResponses.vue?vue&type=script&lang=js&"
import style0 from "./formMCQResponses.vue?vue&type=style&index=0&id=655809d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655809d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VTextField})
